import React, { useState } from "react";

const inputClass =
  "rounded-lg border border-blue-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition px-4 py-3 text-base outline-none";
const textareaClass =
  "rounded-lg border border-blue-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition px-4 py-3 text-base outline-none min-h-[100px] resize-none";

const initialFormData = {
  razaoSocial: "",
  cnpjParceiro: "",
  contatoParceiroNome: "",
  contatoParceiroEmail: "",
  contatoParceiroTelefone: "",
  instituicaoNome: "",
  instituicaoCNPJ: "",
  instituicaoEndereco: "",
  contatoInstituicaoNome: "",
  contatoInstituicaoCargo: "",
  contatoInstituicaoEmail: "",
  contatoInstituicaoTelefone: "",
  numeroAlunos: "",
  moduloControleAcesso: false,
  moduloComunicacaoIntegrada: false,
  moduloWhiteLabel: "",
  moduloMonitoramentoIA: false,
  moduloGestaoAcademicaFinanceira: false,
  moduloIntegracao: "",
  moduloAutomacao: false,
  moduloOutros: "",
  valorEstimado: "",
  estagioNegociacao: "",
  estagioOutroDescricao: "",
  dataPrevistaFechamento: "",
  observacoes: "",
  descricaoComprovacao: "",
  responsavelDeclaracao: false,
  dataSolicitacao: "",
  nomeResponsavelParceiro: "",
};

const FormEducationOpportunity = () => {
  const [formError, setFormError] = useState<string | null>(null);
  const [formSuccess, setFormSuccess] = useState(false);
  const [formData, setFormData] = useState(initialFormData);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const target = e.target as HTMLInputElement;
    const { name, value, type, checked } = target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormError(null);
    setFormSuccess(false);
    try {
      const res = await fetch("/backend/api/updateSheetEducationOpportunity", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      if (!res.ok) {
        const errorText = await res.text();
        setFormError("Erro ao enviar o formulário: " + errorText);
        return;
      }
      const data = await res.json();
      if (data?.error) {
        setFormError("Erro ao enviar o formulário: " + data.error);
      } else {
        setFormSuccess(true);
        setFormData(initialFormData);
      }
    } catch (err: unknown) {
      if (err instanceof Error) {
        setFormError("Erro ao enviar o formulário: " + err.message);
      } else {
        setFormError("Erro ao enviar o formulário: Erro desconhecido");
      }
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-white/90 rounded-2xl shadow-2xl p-8 w-full max-w-[150vh] flex flex-col gap-5 mt-8"
    >
      <h2 className="text-blue-900 text-2xl font-bold mb-2 text-center font-roboto tracking-tight">
        Formulário de Registro de Oportunidade AlertAI - Revenda
      </h2>
      <h3 className="font-semibold mb-2 text-blue-700">
        1. Dados do Parceiro Solicitante:
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <input
          name="razaoSocial"
          value={formData.razaoSocial}
          onChange={handleChange}
          className={inputClass}
          placeholder="Razão Social"
          required
        />
        <input
          name="cnpjParceiro"
          value={formData.cnpjParceiro}
          onChange={handleChange}
          className={inputClass}
          placeholder="CNPJ"
          required
        />
        <input
          name="contatoParceiroNome"
          value={formData.contatoParceiroNome}
          onChange={handleChange}
          className={inputClass}
          placeholder="Nome do Contato Principal"
          required
        />
        <input
          name="contatoParceiroEmail"
          value={formData.contatoParceiroEmail}
          onChange={handleChange}
          className={inputClass}
          placeholder="E-mail do Contato"
          type="email"
          required
        />
        <input
          name="contatoParceiroTelefone"
          value={formData.contatoParceiroTelefone}
          onChange={handleChange}
          className={inputClass}
          placeholder="Telefone do Contato"
          required
        />
      </div>
      <h3 className="font-semibold mb-2 text-blue-700">
        2. Dados do Cliente Final (Instituição de Ensino):
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <input
          name="instituicaoNome"
          value={formData.instituicaoNome}
          onChange={handleChange}
          className={inputClass}
          placeholder="Nome da Instituição"
          required
        />
        <input
          name="instituicaoCNPJ"
          value={formData.instituicaoCNPJ}
          onChange={handleChange}
          className={inputClass}
          placeholder="CNPJ da Instituição"
          required
        />
        <input
          name="instituicaoEndereco"
          value={formData.instituicaoEndereco}
          onChange={handleChange}
          className={inputClass}
          placeholder="Endereço Completo"
          required
        />
        <input
          name="contatoInstituicaoNome"
          value={formData.contatoInstituicaoNome}
          onChange={handleChange}
          className={inputClass}
          placeholder="Nome do Contato Principal na Instituição"
          required
        />
        <input
          name="contatoInstituicaoCargo"
          value={formData.contatoInstituicaoCargo}
          onChange={handleChange}
          className={inputClass}
          placeholder="Cargo do Contato"
          required
        />
        <input
          name="contatoInstituicaoEmail"
          value={formData.contatoInstituicaoEmail}
          onChange={handleChange}
          className={inputClass}
          placeholder="E-mail do Contato na Instituição"
          type="email"
          required
        />
        <input
          name="contatoInstituicaoTelefone"
          value={formData.contatoInstituicaoTelefone}
          onChange={handleChange}
          className={inputClass}
          placeholder="Telefone do Contato na Instituição"
          required
        />
      </div>
      <h3 className="font-semibold mb-2 text-blue-700">
        3. Detalhes da Oportunidade:
      </h3>
      <div className="mb-2 flex flex-col gap-2">
        <input
          name="numeroAlunos"
          value={formData.numeroAlunos}
          onChange={handleChange}
          className={inputClass}
          placeholder="Número Estimado de Alunos"
          type="number"
          required
        />
        <div>
          <label className="block font-medium mb-1">
            Soluções/Módulos AlertAI de Interesse Inicial:
          </label>
          <div className="flex flex-col gap-1">
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                name="moduloControleAcesso"
                checked={formData.moduloControleAcesso}
                onChange={handleChange}
              />{" "}
              Controle de Acesso Inteligente
            </label>
            <label className="flex flex-col md:flex-row md:items-center gap-2">
              <span className="flex items-center gap-2">
                <input
                  type="checkbox"
                  name="moduloComunicacaoIntegrada"
                  checked={formData.moduloComunicacaoIntegrada}
                  onChange={handleChange}
                />{" "}
                Comunicação Integrada
              </span>
              <span className="ml-2 flex items-center gap-1">
                Sim{" "}
                <input
                  type="radio"
                  name="moduloWhiteLabel"
                  value="sim"
                  checked={formData.moduloWhiteLabel === "sim"}
                  onChange={handleChange}
                />{" "}
                Sim
              </span>
              <span className="ml-2 flex items-center gap-1">
                Não{" "}
                <input
                  type="radio"
                  name="moduloWhiteLabel"
                  value="nao"
                  checked={formData.moduloWhiteLabel === "nao"}
                  onChange={handleChange}
                />{" "}
                Não
              </span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                name="moduloMonitoramentoIA"
                checked={formData.moduloMonitoramentoIA}
                onChange={handleChange}
              />{" "}
              Monitoramento IA
            </label>
            <label className="flex flex-col md:flex-row md:items-center gap-2">
              <span className="flex items-center gap-2">
                <input
                  type="checkbox"
                  name="moduloGestaoAcademicaFinanceira"
                  checked={formData.moduloGestaoAcademicaFinanceira}
                  onChange={handleChange}
                />{" "}
                Gestão Acadêmica
              </span>
              <span className="ml-2 flex items-center gap-1">
                Integração?
                <input
                  type="radio"
                  name="moduloIntegracao"
                  value="sim"
                  checked={formData.moduloIntegracao === "sim"}
                  onChange={handleChange}
                />{" "}
                Sim
              </span>
              <span className="ml-2 flex items-center gap-1">
                <input
                  type="radio"
                  name="moduloIntegracao"
                  value="nao"
                  checked={formData.moduloIntegracao === "nao"}
                  onChange={handleChange}
                />{" "}
                Não
              </span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                name="moduloAutomacao"
                checked={formData.moduloAutomacao}
                onChange={handleChange}
              />
              Automação
            </label>
            <label className="flex items-center gap-2">
              <input
                name="moduloOutros"
                value={formData.moduloOutros}
                onChange={handleChange}
                className={inputClass}
                placeholder="Outros - especificar"
              />
              <input
                name="valorEstimado"
                value={formData.valorEstimado}
                onChange={handleChange}
                className={inputClass}
                placeholder="Valor Estimado do Projeto (R$)"
                type="number"
                required
              />
            </label>
          </div>
        </div>
        <input
          className={inputClass}
          placeholder="Valor Estimado do Projeto (R$)"
          type="number"
          required
        />
        <div>
          <label className="block font-medium mb-1">
            Estágio Atual da Negociação:
          </label>
          <div className="flex flex-col gap-1">
            {[
              "Contato Inicial",
              "Apresentação",
              "Levantamento",
              "Proposta",
              "Negociação",
            ].map((etapa) => (
              <label key={etapa}>
                <input
                  type="radio"
                  name="estagioNegociacao"
                  value={etapa}
                  checked={formData.estagioNegociacao === etapa}
                  onChange={handleChange}
                />{" "}
                {etapa}
              </label>
            ))}
          </div>
          <input
            name="estagioOutroDescricao"
            value={formData.estagioOutroDescricao}
            onChange={handleChange}
            className={inputClass}
            placeholder="Outro - especificar"
          />
        </div>
        <input
          name="dataPrevistaFechamento"
          value={formData.dataPrevistaFechamento}
          onChange={handleChange}
          className={inputClass}
          type="date"
          required
        />
        <textarea
          name="observacoes"
          value={formData.observacoes}
          onChange={handleChange}
          className={textareaClass}
          placeholder="Observações Adicionais Relevantes"
        />
      </div>
      <h3 className="font-semibold mb-2 text-blue-700">
        4. Comprovação do Início da Negociação:
      </h3>
      <input
        name="descricaoComprovacao"
        value={formData.descricaoComprovacao}
        onChange={handleChange}
        className={inputClass}
        placeholder="Descrição da Comprovação Anexada"
      />
      <input className={inputClass} type="file" />
      <h3 className="font-semibold mb-2 text-blue-700">5. Declaração:</h3>
      <div className="mb-2">
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            name="responsavelDeclaracao"
            checked={formData.responsavelDeclaracao}
            onChange={handleChange}
            required
          />{" "}
          que as informações fornecidas neste formulário são verdadeiras e
          precisas, e que li e concordo com os termos da Política de Registro e
          Proteção de Oportunidades AlertAI.
        </label>
      </div>
      <input
        name="dataSolicitacao"
        value={formData.dataSolicitacao}
        onChange={handleChange}
        className={inputClass}
        type="date"
        required
      />
      <input
        name="nomeResponsavelParceiro"
        value={formData.nomeResponsavelParceiro}
        onChange={handleChange}
        className={inputClass}
        placeholder="Nome do Responsável no Parceiro"
        required
      />
      <button
        className="mt-2 bg-blue-700 hover:bg-blue-800 transition text-white font-semibold rounded-lg py-3 text-lg shadow-md"
        type="submit"
      >
        Enviar
      </button>
      {formError && (
        <div className="text-red-600 font-semibold mt-2">{formError}</div>
      )}
      {formSuccess && (
        <div className="text-green-600 font-semibold mt-2">
          Formulário enviado com sucesso!
        </div>
      )}
    </form>
  );
};

export default FormEducationOpportunity;
